import { render, staticRenderFns } from "./StepModelRequirementsSummaryTable.vue?vue&type=template&id=03c43591&"
import script from "./StepModelRequirementsSummaryTable.vue?vue&type=script&lang=js&"
export * from "./StepModelRequirementsSummaryTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
